import { render, staticRenderFns } from "./CadastroContratosOriginacaoEmpresa.vue?vue&type=template&id=3fc422fd&lang=pug"
import script from "./CadastroContratosOriginacaoEmpresa.vue?vue&type=script&lang=js"
export * from "./CadastroContratosOriginacaoEmpresa.vue?vue&type=script&lang=js"
import style0 from "./CadastroContratosOriginacaoEmpresa.vue?vue&type=style&index=0&id=3fc422fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports